export const TOKENS = {
  UserInteractionRendererProvider: '@trustedshops/tswp-core-ui-implementation:UserInteractionRendererProvider'
};
